const getWishlistPriceDropData = (itemCode, itemImage, itemPrice) => {
  const isLocal = localStorage.getItem('wishlistPriceDrop');
  if (isLocal === null) {
    const data = JSON.stringify([{ itemCode, itemImage, itemPrice }]);
    localStorage.setItem('wishlistPriceDrop', data);
  } else {
    const prevData = JSON.parse(localStorage.getItem('wishlistPriceDrop'));
    const filteredData = prevData?.filter(list => list?.itemCode === itemCode);
    if (!filteredData?.length) {
      const newData = JSON.stringify([...prevData, { itemCode, itemImage, itemPrice }]);
      localStorage.setItem('wishlistPriceDrop', newData);
    }
  }
};

export default getWishlistPriceDropData;
